import { Inject, Injectable } from '@angular/core';
import { UnsafeDataLayer, UNSAFE_DATA_LAYER } from '../../..';
import type { DataLayerBaseEvent, DataLayerEventTypes } from './google-analytics.model';

// Abstract pushes to dataLayer behind events whenever possible. Try to not call tracking in some leaf component.
@Injectable({
  providedIn: 'root',
})
export class GoogleAnalyticsService {
  private nrOfItemsReset = 0;

  constructor(@Inject(UNSAFE_DATA_LAYER) private dataLayer: UnsafeDataLayer) {}

  pushEvent<T extends DataLayerEventTypes | string, U extends DataLayerBaseEvent<T>>(dataLayerEvent: U): boolean {
    const bool = this.dataLayer.push({
      ...this.getResetObjForDataLayer(this.dataLayer),
      ...dataLayerEvent,
    });
    this.dataLayer.push(this.getResetObjForDataLayer(this.dataLayer));
    return bool;
  }

  private getResetObjForDataLayer(dataLayer: UnsafeDataLayer): { [key: string]: string } {
    const itemsToReset = dataLayer.slice(this.nrOfItemsReset);
    this.nrOfItemsReset += itemsToReset.length;
    const allKeysObj = itemsToReset.reduce(
      (acc: { [p: string]: string }, curr: { [p: string]: string }) => Object.assign(acc, curr),
      {}
    );
    for (const key of Object.keys(allKeysObj)) {
      if (key.startsWith('gtm')) {
        delete allKeysObj[key];
      } else {
        allKeysObj[key] = undefined;
      }
    }
    return allKeysObj;
  }
}
